import { render, staticRenderFns } from "./StandardsHomePlaceholder.vue?vue&type=template&id=41451458"
import script from "./StandardsHomePlaceholder.vue?vue&type=script&lang=js"
export * from "./StandardsHomePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports